'use client';

import type { Dispatch, ReactNode, SetStateAction } from 'react';
import { useTranslations } from 'next-intl';
import { useCallback, useEffect, useRef, useState } from 'react';
import { CustomSwipeableDrawer } from '~/components/commons/CustomSwipeableDrawer/CustomSwipeableDrawer';

export const TranslationRatingWrapper = ({
  children,
  isSBreakpoint,
  isRatingOpen,
  setIsRatingOpen,
}: {
  children: ReactNode;
  isSBreakpoint: boolean;
  isRatingOpen: boolean;
  setIsRatingOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const t = useTranslations('GLOBAL.TRANSLATION_RATING');
  const ref = useRef<HTMLDivElement>(undefined);
  const [hasOpen, setHasOpen] = useState(false);

  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node))
        setIsRatingOpen(false);
    },
    [setIsRatingOpen],
  );

  useEffect(() => {
    if (hasOpen && !isSBreakpoint) {
      document.addEventListener('click', handleClickOutside);
      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    } else {
      setHasOpen(true);
    }
  }, [handleClickOutside, hasOpen, isSBreakpoint]);

  return isSBreakpoint
    ? (
        <CustomSwipeableDrawer
          dataTestId="translation-rating-drawer"
          open={isRatingOpen}
          title={t('LABEL')}
          onClose={() => setIsRatingOpen(false)}
          onOpen={() => setIsRatingOpen(true)}
        >
          {children}
        </CustomSwipeableDrawer>
      )
    : (
        <div
          ref={ref}
          className="flyout flyout--bottom"
          data-testid="translation-rating-flyout"
        >
          <span className="flyout__inner">
            <div className="translate__rating__container">{children}</div>
          </span>
        </div>
      );
};
